<span (click)="doCancel($event)"><ng-content></ng-content>&nbsp;<mat-icon>cancel</mat-icon></span>
